import React from "react";
import { OrderTableFooterButton } from "../../common/Buttons";
import { AiOutlineClose } from "react-icons/ai";

function ModalSpecial(props) {
  return (
    <div className={"modal-wrapper"}>
      <div onClick={() => props.onClose()} className={"modal-backdrop"} />

      <div
        className="modal-dialog modal-edit modal-editOrders"
        style={{ zIndex: 101, ...props.style }}
      >
        <div className="modal-content px-2 py-2" style={{ height: "100vh" }}>
          {props.text && (
            <>
              <div className="col">
                <span className="d-flex align-items-center justify-content-between font-weight-bold d-block modal-title text-orange text-xl">
                  {props.text}
                  <AiOutlineClose
                    className="pl-2 text-black cursor-pointer"
                    size={25}
                    // color={"#BFBFBF"}
                    onClick={() => props.onClose()}
                  />
                </span>
              </div>
            </>
          )}
          <div
            className="modal-body"
            style={{ height: "100vh", overflow: "auto" }}
          >
            {props.children}
          </div>
          {props.bottoms && (
            <div className="modal-footer justify-content-center">
              <OrderTableFooterButton
                color="#ee3624"
                text="Save"
                handleSave={props.handleSave}
              />

              <OrderTableFooterButton
                color="silver"
                text="Close"
                onClick={() => props.onClose()}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalSpecial;
